(function () {
  'use strict';

  if (window.FsInitSectionCarousels) {
    window.FsInitSectionCarousels();
    return;
  }

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initSectionCarousels(root = document) {
    root.querySelectorAll('[data-fs-carousel]:not([data-fs-carousel-ready])').forEach((carousel) => {
      carousel.dataset.fsCarouselReady = 'true';

      const track = carousel.querySelector('[data-fs-carousel-track]');
      const prev = carousel.querySelector('[data-fs-carousel-prev]');
      const next = carousel.querySelector('[data-fs-carousel-next]');
      if (!track || !prev || !next) return;

      const canScroll = () => track.scrollWidth > track.clientWidth + 2;
      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = !canScroll() || track.scrollLeft <= 2;
        next.disabled = !canScroll() || track.scrollLeft >= max;
      };
      const getStep = () => {
        const first = track.firstElementChild;
        if (!first) return track.clientWidth * 0.9;
        const styles = window.getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
        return first.getBoundingClientRect().width + gap;
      };

      prev.addEventListener('click', () => {
        track.scrollBy({ left: getStep() * -1, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      });
      next.addEventListener('click', () => {
        track.scrollBy({ left: getStep(), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);

      if ('MutationObserver' in window) {
        new MutationObserver(update).observe(track, { childList: true });
      }

      update();
    });
  }

  window.FsInitSectionCarousels = initSectionCarousels;
  document.addEventListener('DOMContentLoaded', () => initSectionCarousels());
  document.addEventListener('shopify:section:load', (event) => initSectionCarousels(event.target));
  initSectionCarousels();
})();
